import { FETCH_DELIVERY_PARTNER_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
  selectList: [],
  others: {},
};

const deliveryPartnerListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DELIVERY_PARTNER_LIST:
      return {
        list: action.payload,
        others: action.others,
        selectList: action.payload.filter((item) => item.is_active),
      };

    default:
      return state;
  }
};

export default deliveryPartnerListReducer;
